import TweenMax from 'TweenMax';
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';

export default () => {
  const ctrl = new ScrollMagic.Controller({
    globalSceneOptions: {
      triggerHook: 'onLeave'
    }
  });
  if ($('.why').length) {
    $('.why').each(function() {
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -950
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }
  if ($('.consultation').length) {
    $('.consultation').each(function() {
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -950
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }
  if ($('.text-section').length) {
    $('.text-section').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: - 900
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.trigger-section').length) {
    $('.trigger-section').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -800
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.requirements').length) {
    $('.requirements').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: - 1000
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.review').length) {
    $('.review').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -950
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.special').length) {
    $('.special').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -1000
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.docs').length) {
    $('.docs').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -950
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.services').length) {
    $('.services').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -800
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.calculation').length) {
    $('.calculation').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -950
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.history').length) {
    $('.history').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -900
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.about-video').length) {
    $('.about-video').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -1000
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.about-info').length) {
    $('.about-info').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -900
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.what-we-do').length) {
    $('.what-we-do').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -900
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.main-form').length) {
    $('.main-form').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -900
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }

  if ($('.certificates-block').length) {
    $('.certificates-block').each(function thumbAnimation() {
      const element = $(this);
      const thumbScene = new ScrollMagic.Scene({
        triggerElement: this,
        offset: -900
      })
      .setClassToggle(this, "active");
      thumbScene.addTo(ctrl);
    })
  }




  // Define a blank array for the effect positions. This will be populated based on width of the title.
  const bArray = [];
  // Define a size array, this will be used to vary bubble sizes
  const sArray = [4, 6, 8, 10];
  // Push the header width values to bArray
  for (let i = 0; i < $('.bubbles').width(); i += 1) {
    bArray.push(i);
  }
  // Function to select random array element
  // Used within the setInterval a few times
  function randomValue(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
  // setInterval function used to create new bubble every 350 milliseconds
  setInterval(() => {
    // Get a random size, defined as variable so it can be used for both width and height
    const size = randomValue(sArray);
    // New bubble appeneded to div with it's size and left position being set inline
    // Left value is set through getting a random value from bArray
    $('.bubbles').append('<div class="individual-bubble" style="left: ' + randomValue(bArray) + 'px; width: ' + size + 'px; height:' + size + 'px;"></div>');
    // Animate each bubble to the top (bottom 100%) and reduce opacity as it moves
    // Callback function used to remove finsihed animations from the page
    $('.individual-bubble').animate({
      'bottom': '100%',
      'opacity': '-=0.7'
    }, 2000, function bubbleRemove() {
      $(this).remove()
    }
    );
  }, 350);

}



// WEBPACK FOOTER //
// app/scripts/components/animations.js